import { Flex, Spin } from 'antd';

import type { SpinProps } from 'antd';
import type { ReactNode } from 'react';

interface LoaderProps extends SpinProps {
  children?: ReactNode;
  /** Standalone loading state — centers the spinner in the available space. */
  centered?: boolean;
  /** Reserve vertical space for the centered variant. */
  minHeight?: number | string;
}

const Loader = ({
  children,
  className,
  centered,
  minHeight,
  ...rest
}: LoaderProps) => {
  if (centered) {
    return (
      <Flex
        vertical
        flex={1}
        align="center"
        justify="center"
        className={className}
        style={{ minHeight }}
      >
        <Spin {...rest} />
      </Flex>
    );
  }

  return (
    <Flex vertical flex={1} className={className}>
      <Spin {...rest}>{children}</Spin>
    </Flex>
  );
};

export default Loader;
